import { render } from "./Production.vue?vue&type=template&id=51a94582&scoped=true&ts=true"
import script from "./Production.vue?vue&type=script&lang=ts"
export * from "./Production.vue?vue&type=script&lang=ts"

import "./Production.vue?vue&type=style&index=0&id=51a94582&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a94582"]])

export default __exports__